import { Cascader } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceCascader",
  mixins: [Cascader, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    isDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
